


















import TitleWidget from "@/components/common/TitleWidget.vue";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'TextUs',
  components: {TitleWidget},
  data: () => {
    return {
      locale: stringsKeys,
    }
  }
}
